import React from "react";
import styles from "./SelectInput.module.css";

export default function SelectInput({
  value,
  onChange,
  disabled = false,
  className = "",
  children,
  ...rest
}) {
  return (
    <select
      className={[styles.select, className].join(" ")}
      value={value}
      onChange={onChange}
      disabled={disabled}
      {...rest}
    >
      {children}
    </select>
  );
}